export default __webpack_public_path__ + "static/media/225.8d3056c2.png";